export default function camelCase(str) {
  const words = str.split(/[-_]/);
  const camelCaseWords = words.map((word, index) => {
    if(index) return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    return word.toLowerCase();
  });
  return camelCaseWords.join("");
}
